import React from 'react';
import { Hero } from './components/Hero';
import { StatsAndProof, ExtendedTestimonials } from './components/ProofSections';
import { PainPoints } from './components/PainPoints';
import { ProductOffer } from './components/ProductOffer';
import { Pricing } from './components/Pricing';
import { CostSection, FooterAndProofPopup, GuaranteeAndFaq } from './components/ClosingSections';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-brand-ink text-white" data-id="element-0" data-mp="2mlu9cnzhzpsr">
      <MetaPixel data-id="element-1" data-mp="2mjpy1kz9roig" />
      <Hero data-id="element-2" data-mp="31aqhel1k12td" />
      <StatsAndProof data-id="element-3" data-mp="31b8jvzet8d9q" />
      <PainPoints data-id="element-4" data-mp="31brzvakwgrl4" />
      <ProductOffer data-id="element-5" data-mp="31c9ygdv1bhw7" />
      <Pricing showAnchor data-id="element-6" data-mp="31cjn9y4cfj0b" />
      <ExtendedTestimonials data-id="element-7" data-mp="2wjgqlh49rtfw" />
      <GuaranteeAndFaq data-id="element-8" data-mp="2wj8cjlweui34" />
      <CostSection data-id="element-9" data-mp="2wip6p3k1bk5g" />
      <Pricing data-id="element-10" data-mp="2wi5pxq64f1t0" />
      <FooterAndProofPopup data-id="element-11" data-mp="28u5z6q8t7bef" />
    </main>;
}